

export const INGREDIENT_PRICES = {
    Salad: 4.5,
    Meat: 15,
    Cheese: 4.3,
    Tomato:2,
    
}